import { allowedDoFollowDomains } from './constants'

export const addParameterToURL = (url: string, param: string) => {
  if (param) {
    const newUrl = url + (url.split('?')[1] ? '&' : '?') + param
    return newUrl
  } else return url
}

export const addQueryParamsToApi = (
  url: string,
  params?: Record<string, string>,
) => {
  if (params && Object.keys(params).length > 0) {
    const newUrl = `${url}?${new URLSearchParams(params)}`
    return newUrl
  } else {
    return url
  }
}

export const addQueryParamsToApiV2 = (
  url: string,
  params?: Record<string, string>,
) => {
  if (url.includes('?')) {
    const newUrl = `${url}&${new URLSearchParams(params ?? '')}`
    return newUrl
  } else {
    const newUrl = `${url}?${new URLSearchParams(params ?? '')}`
    return newUrl
  }
}

export const ruppeeCoversion = (val?: number) => {
  if (val) {
    const isDecimal = val % 1 !== 0 && !isNaN(val)
    let item = isDecimal ? val.toString().split('.')[0] : val
    item = item.toString()
    let lastThree = item.substring(item.length - 3)
    const otherNumbers = item.substring(0, item.length - 3)
    if (otherNumbers != '') lastThree = `,${lastThree}`
    const res = `${otherNumbers.replace(
      /\B(?=(\d{2})+(?!\d))/g,
      ',',
    )}${lastThree}`
    return isDecimal ? `${res}.${val.toString().split('.')[1]}` : res
  }
  return val
}

export const getPathname = (asPath: string) => {
  const pathname = asPath.split('?')[0]
  return pathname
}

export const getHostDomain = (): string => {
  if (typeof window !== 'undefined') {
    return window.location.hostname
  }
  return ''
}

export const getAnchorTagsWithNoFollow = (htmlString: string) => {
  const anchorRegex = /<a\s+(?:[^>]*?\s+)?href="([^"]*)".*?>(.*?)<\/a>/gi
  const modifiedHtmlString = htmlString.replace(
    anchorRegex,
    (match, href, innerText) => {
      let isSafeForDoFollow = false
      for (const domain of allowedDoFollowDomains) {
        if (href.includes(domain)) {
          isSafeForDoFollow = true
          break
        }
      }
      if (!isSafeForDoFollow) {
        return `<a href="${href}" rel="nofollow noopener noreferrer" target="_blank">${innerText}</a>`
      }
      return match
    },
  )
  return modifiedHtmlString
}

export function forwardQueryParams(path: string, params: URLSearchParams) {
  const queryString = params.toString()
  if (queryString === '') {
    return path
  }
  return `${path}?${queryString}`
}

export const getMaskedPrice = (price: string, maskAllValues: boolean) => {
  if (maskAllValues) {
    return '₹•••'
  }
  return price
}

export const getMaskedPercentage = (
  percentage: string,
  maskAllValues: boolean,
) => {
  if (maskAllValues) {
    return '•••%'
  }
  return percentage
}
